import { TPlayerLayoutStylesSchema } from './PlayerLayout.styles';

const styles: Partial<TPlayerLayoutStylesSchema> = {
  row: {
    borderBottomWidth: '1px',
    borderBottomColor: 'rgba(255, 255, 255, .15)',
    pb: '2',
    boxShadow: '1px -1.5px 0px -1px #292f36 inset',
  },

  propWrapper: {
    justifyContent: 'flex-end',
  },
  btnGroupWrapper: {
    borderRadius: '5px',
    bgGradient: 'linear(to-b, beta.400, beta.500)',
    minW: '90px',
    px: '1.5',

    sx: {
      '> p': {
        fontFamily: 'heading', 
        fontWeight: 'inherit',
        bg: 'blackAlpha.700',
        h: '100%',
        px: '1',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: 'beta.400',
        textShadow: 'none',
      },
    }
  },
  btnGroupText: {
    fontSize: 'sm',
    color: 'blackAlpha.700',
    fontWeight: 'black',
    fontFamily: 'roboto',
    textShadow: '1px 0px 0px rgba(255, 255, 255, 0.45)',
  },
  btnGroupIcon: {
    color: 'blackAlpha.700',
  },
  name: {
    color: 'white',
  },
};
export default styles;
